import * as React from 'react'
import styled from 'styled-components'
import logo from '../logo.png'
import logoSmall from '../logo-small.png'
import config from '../config'

const LogoContainer = styled.div`
  display: flex;
  @media (${({ theme }) => theme.screenSizes.md}) {
    flex-direction: column;
  }
`

const LogoImg = styled.img`
  max-height: 76px;
  @media (${({ theme }) => theme.screenSizes.md}) {
    display: none;
  }
`

LogoImg.displayName = 'LogoImg'

const LogoSmallImg = styled.img`
  height: 100%;
  display: none;
  @media (${({ theme }) => theme.screenSizes.md}) {
    display: block;
    height: 48px;
  }
`

LogoSmallImg.displayName = 'LogoSmallImg'

const Logos = styled.div`
  display: flex;
  justify-content: center;
  padding: 0.75rem 0;
`

const DescriptorContainer = styled.div`
  align-self: center;
  color: ${({ theme }) => theme.palette.nswBrandDark};
  padding-left: 2.75rem;
  line-height: 1.75rem;

  @media screen and (${({ theme }) => theme.screenSizes.md}) {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 0;
    align-self: flex-start;
  }
`
DescriptorContainer.displayName = 'DescriptorContainer'

const Descriptor = styled.div`
  font-weight: 700;
  font-size: ${({ theme }) => theme.font.heading};
`

export function FormsAppLogo() {
  const descriptors = React.useMemo<{
    primary: string
    secondary?: string
  }>(() => {
    if (config.DEPARTMENT === 'DPI') {
      return {
        primary: 'Department of Primary Industries',
        secondary: 'and Regional Development',
      }
    } else {
      return {
        primary: 'Food Authority',
      }
    }
  }, [])

  return (
    <LogoContainer>
      <Logos>
        <LogoImg src={logo} alt="Logo" />
        <LogoSmallImg src={logoSmall} alt="Logo" />
      </Logos>
      <DescriptorContainer>
        <Descriptor>{descriptors.primary}</Descriptor>
        {descriptors.secondary && (
          <Descriptor>{descriptors.secondary}</Descriptor>
        )}
      </DescriptorContainer>
    </LogoContainer>
  )
}
